import { CardVariant } from "../../../models/CardVariant";
import { IFilterCommand } from "../IFilterCommand";

export class PrimaryVariantFilter<TItem extends CardVariant> implements IFilterCommand<TItem, void> {
    isMatch(item: TItem, filters: void): boolean {
        return item.isPrimaryVariant;
    }
}